import { styled } from '@ringcentral/juno';

export const Container = styled.div`
  position: relative;
`;
